export const THEADERMOCK_PROJECTS = [
  { name: "Nome do Projeto", value: "name" },
  { name: "Clientes", value: "clientName" },
  { name: "Estado", value: "status" },
];

export const SELECTFILTER_PROJECTS = [
  { name: "Nome", value: 1 },
  { name: "Cliente", value: 2 },
];

export const CASE_FILTER_PROJECTS = ["name", "clientName"];
